import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Navbar";
import { scrollToId } from "@/api";

export default function Footer() {
  return (
    <footer id="contact" className="scroll-mt-24 border-t border-white/10 bg-onyx-800/60" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <Logo />
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
            Tripsandtrick Travel Private Limited — curated international holidays with flights,
            hotels, transfers and sightseeing, all under one roof.
          </p>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Explore</h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-300">
            {[["Destinations", "destinations"], ["Packages", "packages"], ["Why T&T", "why-us"]].map(([label, id]) => (
              <li key={id}>
                <button onClick={() => scrollToId(id)} className="hover:text-gold transition-colors">{label}</button>
              </li>
            ))}
            <li><Link to="/admin" data-testid="footer-admin-link" className="hover:text-gold transition-colors">Admin Portal</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Talk to us</h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-300">
            <li className="flex items-center gap-3"><Phone size={15} className="text-gold" /><a href="tel:+919319204006" className="hover:text-gold transition-colors">+91 93192 04006</a></li>
            <li className="flex items-center gap-3"><Mail size={15} className="text-gold" /><a href="mailto:himanshu@tripsandtrick.com" className="hover:text-gold transition-colors">himanshu@tripsandtrick.com</a></li>
            <li className="flex items-start gap-3"><MapPin size={15} className="text-gold mt-0.5" /><span>Tripsandtrick Travel Pvt. Ltd.<br />SCO 186, Sector 28, HUDA Market,<br />Faridabad, Haryana 121001</span></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <div className="rounded-2xl overflow-hidden border border-white/10" data-testid="footer-map-embed">
          <iframe
            title="T&T Travels office — SCO 186, Sector 28, HUDA Market, Faridabad"
            src="https://maps.google.com/maps?q=SCO%20186%2C%20Sector%2028%2C%20HUDA%20Market%2C%20Faridabad%2C%20Haryana%20121001&t=&z=16&ie=UTF8&iwloc=&output=embed"
            className="w-full h-56 grayscale invert-[0.92] contrast-[0.9] opacity-90"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Tripsandtrick Travel Private Limited. All rights reserved.
      </div>
    </footer>
  );
}
